import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipeModule } from '../../pipes/safe/safe.pipe.module';
import { IFrameComponent } from './i-frame.component';


@NgModule({
  declarations: [
    IFrameComponent
  ],
  imports: [
    CommonModule,
    SafePipeModule
  ],
  exports: [
    IFrameComponent
  ]
})
export class IFrameModule {
}
